export function isAccordionPreExpanded({
  ageInMonths,
  ageInMonthsAtendimentoAnterior,
  hasValuesAntendimentoAnterior,
  isMChatAnteriorRiscoBaixo,
}: {
  ageInMonths: number
  ageInMonthsAtendimentoAnterior: number
  hasValuesAntendimentoAnterior: boolean
  isMChatAnteriorRiscoBaixo: boolean
}) {
  if (ageInMonths >= 16 && !hasValuesAntendimentoAnterior) {
    return true
  }
  if (hasValuesAntendimentoAnterior && isMChatAnteriorRiscoBaixo) {
    return !(ageInMonths < 24 || ageInMonthsAtendimentoAnterior > 24)
  }
  return false
}
